
import { defineComponent, PropType } from 'vue'

import type { InvoiceStatusLabel, InvoiceView } from '~/utils/billing'

export default defineComponent({
  name: 'V2RecentInvoices',
  props: {
    invoices: {
      type: Array as PropType<InvoiceView[]>,
      default: () => []
    },
    loading: {
      type: Boolean,
      default: false
    },
    title: {
      type: String,
      default: 'Recent invoices'
    },
    emptyText: {
      type: String,
      default: 'No invoices yet.'
    }
  },
  methods: {
    statusColor(status: InvoiceStatusLabel): string {
      switch (status) {
        case 'Paid':
          return 'juniper'
        case 'Open':
          return 'aqua'
        case 'Draft':
          return 'vanilla'
        case 'Void':
        case 'Uncollectible':
          return 'cherry'
        default:
          return 'vanilla'
      }
    }
  }
})
